(() => {
  if (window.SheltaFlexMobile) return;
  window.SheltaFlexMobile = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const roots = '.sf-system-explorer,.sf-timeline,.sf-camping-scene,.sf-configurator,.sf-extension-advisor,.sf-flextrash';
  const timers = new WeakMap();
  let variants = {};
  function readVariants() {
    try { variants = JSON.parse(document.querySelector('[data-sf-set-variants]')?.textContent || '{}'); }
    catch { variants = {}; }
  }
  function updateSetLinks(root) {
    const color = root.querySelector('.sf-flextrash__color[aria-pressed="true"]')?.dataset.title;
    if (!color) return;
    root.querySelectorAll('.sf-flextrash__actions a').forEach(link => {
      if (!link.dataset.sfOriginalHref) link.dataset.sfOriginalHref = link.getAttribute('href');
      const url = new URL(link.dataset.sfOriginalHref, window.location.origin);
      if (url.origin !== window.location.origin) return;
      const handle = url.pathname.split('/').filter(Boolean).pop();
      const variant = variants[handle]?.find(item => item.color === color);
      if (!variant) return;
      url.searchParams.set('variant', variant.id);
      link.href = url.pathname + url.search + url.hash;
    });
  }
  function init(scope) {
    readVariants();
    scope.querySelectorAll(roots).forEach(root => {
      if (!root.querySelector('.sf-mobile-status')) {
        const status = document.createElement('span');
        status.className = 'sf-mobile-status';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        status.setAttribute('aria-atomic', 'true');
        root.append(status);
      }
    });
    scope.querySelectorAll('.sf-flextrash').forEach(updateSetLinks);
    scope.querySelectorAll('.sf-faq').forEach((root, index) => {
      const group = root.id || 'sf-faq-group-' + index;
      root.querySelectorAll('details.sf-faq__item').forEach(item => {
        item.setAttribute('name', group);
      });
    });
    scope.querySelectorAll('main .sf-faq').forEach(root => {
      if (root.querySelector('[data-sf-mobile-faq-link]')) return;
      const inner = root.querySelector('.sf-faq__inner');
      if (!inner) return;
      const link = document.createElement('a');
      link.className = 'sf-mobile-faq-link';
      link.dataset.sfMobileFaqLink = '';
      link.href = '/pages/faq';
      link.textContent = 'Alle Fragen und Antworten →';
      inner.append(link);
    });
  }
  function visibleResult(root) {
    return Array.from(root.querySelectorAll('.sf-configurator__result,.sf-configurator__question,.sf-system-explorer__adapter.is-active,.sf-camping-scene__info.is-active,.sf-timeline__slide.is-active,.sf-extension-advisor__result.is-active,.sf-flextrash__color-title')).find(node => node.getClientRects().length && getComputedStyle(node).display !== 'none');
  }
  function feedback(root, target, trigger) {
    if (!target || !target.getClientRects().length) return;
    const status = root.querySelector('.sf-mobile-status');
    const activeResult = visibleResult(root);
    if (!mobile.matches && activeResult && !root.matches('.sf-flextrash')) target = activeResult;
    const header = document.querySelector('sticky-header');
    const inset = Math.max(header?.getBoundingClientRect().height || 0, 52) + 16;
    const bounds = target.getBoundingClientRect();
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const resultBelowScreen = activeResult && activeResult.getBoundingClientRect().bottom > viewportHeight - 24;
    const message = activeResult?.querySelector('h3')?.textContent.trim() || (activeResult?.matches('h3') ? activeResult.textContent.trim() : trigger.textContent.trim().replace(/\s+/g, ' '));
    if (status && status.textContent !== message) status.textContent = message;
    clearTimeout(timers.get(target));
    target.classList.remove('sf-mobile-result-highlight');
    requestAnimationFrame(() => target.classList.add('sf-mobile-result-highlight'));
    timers.set(target, setTimeout(() => target.classList.remove('sf-mobile-result-highlight'), 750));
    if (bounds.top < inset || bounds.top > viewportHeight * 0.55 || resultBelowScreen) {
      window.scrollTo({top:Math.max(0, window.scrollY + bounds.top - inset), behavior:reduceMotion.matches ? 'auto' : 'smooth'});
    }
  }
  document.addEventListener('toggle', event => {
    const item = event.target;
    if (!item.matches?.('details.sf-faq__item') || !item.open) return;
    const root = item.closest('.sf-faq');
    root?.querySelectorAll('details.sf-faq__item[open]').forEach(other => {
      if (other !== item) other.open = false;
    });
  }, true);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('button');
    if (!trigger) return;
    const root = trigger.closest(roots);
    if (!root) return;
    let target;
    if (trigger.matches('.sf-system-explorer__tab')) target = root.querySelector('.sf-system-explorer__controls');
    else if (trigger.matches('.sf-timeline__arrow,.sf-timeline__step')) target = root.querySelector('.sf-timeline__panel');
    else if (trigger.matches('.sf-camping-scene__hotspot,.sf-camping-scene__mobile-tab')) target = root.querySelector(mobile.matches ? '.sf-camping-scene__image-wrap' : '.sf-camping-scene__info-panel');
    else if (trigger.matches('.sf-configurator__option,.sf-configurator__back,.sf-configurator__restart')) target = root.querySelector('.sf-configurator__panel');
    else if (trigger.matches('.sf-extension-advisor__choice')) target = root.querySelector('.sf-extension-advisor__panel');
    else if (trigger.matches('.sf-flextrash__tab,.sf-flextrash__color')) target = root.querySelector('.sf-flextrash__panel');
    if (!target) return;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (root.matches('.sf-flextrash')) updateSetLinks(root);
      if (root.matches('.sf-configurator')) {
        const result = visibleResult(root);
        if (result?.matches('.sf-configurator__result')) target = result;
      }
      feedback(root, target, trigger);
    }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', () => init(document));
})();

/* Keep the selected product action within reach on mobile. */
(() => {
 if (window.SheltaFlexMobileDock) return;
 window.SheltaFlexMobileDock = true;
 const mobile = window.matchMedia('(max-width: 749px)');
 const viewport = window.visualViewport;
 const specs = [
  {root:'.sf-system-explorer',card:'.sf-system-explorer__adapter',link:'.sf-system-explorer__adapter-button',image:'.sf-system-explorer__adapter-image-wrap'},
  {root:'.sf-camping-scene',card:'.sf-camping-scene__info',link:'.sf-camping-scene__button',image:'.sf-camping-scene__image-wrap',imageRoot:true,start:'.sf-camping-scene__mobile-nav'},
  {root:'.sf-extension-advisor',card:'.sf-extension-advisor__result',link:'.sf-extension-advisor__button',image:'.sf-extension-advisor__visual'},
  {root:'.sf-configurator',card:'.sf-configurator__result',link:'.sf-configurator__result-button',image:'.sf-configurator__result-visual'}
 ];
 const records = new Map();
 let frame = 0;
 const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(schedule) : null;
 const intersectionObserver = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(items=>{
  items.forEach(item=>{const record=records.get(item.target);if(record)record.near=item.isIntersecting;});
  schedule();
 },{rootMargin:'400px 0px'}) : null;
 function setDock(entry, active) {
  const parent = active ? entry.root : entry.slot;
  if (entry.bar.parentElement !== parent) parent.append(entry.bar);
  if (entry.bar.classList.contains('is-docked') !== active) entry.bar.classList.toggle('is-docked', active);
 }
 function schedule() {
  if (records.size && !frame) frame = requestAnimationFrame(update);
 }
 function removeRecord(root, record) {
  record.observer.disconnect();
  resizeObserver?.unobserve(root);
  intersectionObserver?.unobserve(root);
  record.entries.forEach(entry => {setDock(entry,false);entry.slot.style.removeProperty('--sf-dock-space');});
  records.delete(root);
 }
 function update() {
  frame = 0;
  const mobileActive = mobile.matches;
  const bottom = (viewport?.offsetTop || 0) + (viewport?.height || innerHeight);
  const header = mobileActive ? document.querySelector('sticky-header') : null;
  const top = Math.max(viewport?.offsetTop || 0, Math.min(140, header?.getBoundingClientRect().bottom || 0));
  let current = null;
  const measurements = [];
  const disconnected = [];
  // Read geometry together; apply spacing and docking only afterwards.
  records.forEach((record,root) => {
   if (!root.isConnected) {disconnected.push([root,record]);return;}
   record.entries.forEach(entry => {
    if (!mobileActive || !record.near) {measurements.push({entry,space:null});return;}
    const visible = entry.card.getClientRects().length && getComputedStyle(entry.card).display !== 'none';
    const href = entry.link.getAttribute('href');
    if (!visible || !href || href === '#' || !entry.image.getClientRects().length) {
     measurements.push({entry,space:null});return;
    }
    let space = entry.space;
    if (!entry.bar.classList.contains('is-docked')) {
     const style = getComputedStyle(entry.link);
     space = entry.link.getBoundingClientRect().height + (parseFloat(style.marginTop)||0) + (parseFloat(style.marginBottom)||0);
    }
    const image = entry.image.getBoundingClientRect();
    const slot = entry.slot.getBoundingClientRect();
    const card = entry.card.getBoundingClientRect();
    const selectionReached = !entry.start || entry.start.getBoundingClientRect().top + 56 < bottom - 96;
    const shouldDock = image.top < bottom - 120 && selectionReached && slot.top > bottom - space - 24 && card.bottom > top + 24;
    measurements.push({entry,space});
    if (shouldDock && !current) current = entry;
   });
  });
  disconnected.forEach(([root,record])=>removeRecord(root,record));
  measurements.forEach(({entry,space})=>{
   if (space === null) {
    if (entry.slot.style.getPropertyValue('--sf-dock-space')) entry.slot.style.removeProperty('--sf-dock-space');
   } else {
    entry.space = space;
    const value = space+'px';
    if (entry.slot.style.getPropertyValue('--sf-dock-space') !== value) entry.slot.style.setProperty('--sf-dock-space',value);
   }
   setDock(entry,entry===current);
  });
 }
 function reset() {
  records.forEach(record=>record.entries.forEach(entry=>{setDock(entry,false);entry.slot.style.removeProperty('--sf-dock-space');}));
  schedule();
 }
 function init(scope) {
  specs.forEach(spec=> {
   const roots = Array.from(scope.querySelectorAll(spec.root));
   if (scope.matches?.(spec.root)) roots.unshift(scope);
   roots.forEach(root=> {
    if (records.has(root)) return;
    const entries = [];
    root.querySelectorAll(spec.link).forEach(link=> {
     const card = link.closest(spec.card);
     const image = spec.imageRoot ? root.querySelector(spec.image) : card?.querySelector(spec.image);
     if (!card || !image) return;
     let bar = link.closest('.sf-mobile-dock-bar');
     let slot = bar?.parentElement;
     if (!bar) {
      slot = document.createElement('div');slot.className='sf-mobile-action-slot';
      bar = document.createElement('div');bar.className='sf-mobile-dock-bar';
      link.before(slot);slot.append(bar);bar.append(link);
     }
     entries.push({root,card,image,link,bar,slot,start:spec.start ? root.querySelector(spec.start) : null,space:0});
    });
    if (!entries.length) return;
    const observer = new MutationObserver(schedule);
    observer.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['class','hidden','href']});
    records.set(root,{entries,observer,near:!intersectionObserver});
    resizeObserver?.observe(root);intersectionObserver?.observe(root);
   });
  });
  schedule();
 }
 addEventListener('scroll',schedule,{passive:true});
 addEventListener('resize',reset);
 mobile.addEventListener('change',reset);
 viewport?.addEventListener('resize',reset);
 viewport?.addEventListener('scroll',schedule,{passive:true});
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>{
  records.forEach((record,root)=>{if(event.target===root || event.target.contains(root))removeRecord(root,record);});
  schedule();
 });
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
 else init(document);
})();
